import type { Router } from "vue-router";
import { createPermissionGuard } from "./permissionGuard";

export function createGuard(router: Router) {
  // 捕获路由错误
  router.onError((error) => {
    // 判断错误是否为加载动态模块失败
    console.log("捕获路由错误", error);
    if (
      error &&
      error.message &&
      error.message.includes("Failed to fetch dynamically imported module")
    ) {
      window.$message?.error(error.message);
      window.location.reload();
    }
  });
  createPermissionGuard(router);
  // createTabGuard(router);
}
